/* eslint-disable @next/next/no-img-element */
import { Maximize2, RefreshCcw, SendHorizonal, X } from 'lucide-react';
import { useEffect, useRef, useState, useMemo } from 'preact/hooks';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { IProductItem } from '../ecommerce/ProductsList';
import { ProductsList } from '../ecommerce/ProductsList';
import { ShopifyClient } from '../lib/shopify';
import {
    button,
    buttonPrimary,
    buttonSecondary,
    ChatbotContainer,
    ChatbotFooter,
    ChatbotHeader,
    ChatbotHeaderAction,
    ChatbotHeaderLogo,
    dialog,
    dialogActions,
    dialogDescription,
    dialogTitle,
    dialogWrapper,
    IntroMessage,
    MessageForm,
    MessageFormBtn,
    MessageFormInput,
    MessageItemStarting,
    MessagesItemAssistant,
    MessagesItemHuman,
    MessagesWrapper,
    pulseDot1,
    pulseDot2,
    pulseDot3,
    StyleVariables,
    typingIndicator
} from './styles';
import type { IAgentItem } from './type';

const _mockCartData = {
    items: [
        {
            id: 15469530054707,
            properties: {},
            quantity: 5,
            variant_id: 15469530054707,
            key: '15469530054707:4f323f1a5e4f0dd9505b816b2f68f026',
            title: 'Rose Pink Crystal Drop Pendant',
            price: 999,
            original_price: 999,
            presentment_price: 9.99,
            discounted_price: 949,
            line_price: 4745,
            original_line_price: 4995,
            total_discount: 250,
            discounts: [
                {
                    amount: 250,
                    title: 'SUNDAR-M9H3MC8XZ7ST'
                }
            ],
            sku: 'K30005-115000',
            grams: 0,
            vendor: 'OFLARA',
            taxable: true,
            product_id: 1592099110963,
            product_has_only_default_variant: true,
            gift_card: false,
            final_price: 999,
            final_line_price: 4995,
            url: '/products/enchanted-rose-pink-drop-pendant-sterling-silver?variant=15469530054707',
            featured_image: {
                aspect_ratio: 0.784,
                alt: 'Rose Pink Crystal Drop Pendant',
                height: 1110,
                url: 'https://cdn.shopify.com/s/files/1/2340/1009/products/K30005-115000.png?v=1542623188',
                width: 870
            },
            image: 'https://cdn.shopify.com/s/files/1/2340/1009/products/K30005-115000.png?v=1542623188',
            handle: 'enchanted-rose-pink-drop-pendant-sterling-silver',
            requires_shipping: true,
            product_type: 'Necklace',
            product_title: 'Rose Pink Crystal Drop Pendant',
            product_description:
                "\nThe more is merrier, just like this deep pink in teardrop but with a perfect frame of an ecstatic design of crystal engraved in silver plating. A unique design just like you loved one. A pretty Valentine's day gift for her. \n",
            variant_title: null,
            variant_options: ['Default Title'],
            options_with_values: [
                {
                    name: 'Title',
                    value: 'Default Title'
                }
            ],
            line_level_discount_allocations: [],
            line_level_total_discount: 0,
            has_components: false
        },
        {
            id: 15469530054707,
            properties: {},
            quantity: 5,
            variant_id: 15469530054707,
            key: '15469530054707:4f323f1a5e4f0dd9505b816b2f68f026',
            title: 'Rose Pink Crystal Drop Pendant',
            price: 999,
            original_price: 999,
            presentment_price: 9.99,
            discounted_price: 949,
            line_price: 4745,
            original_line_price: 4995,
            total_discount: 250,
            discounts: [
                {
                    amount: 250,
                    title: 'SUNDAR-M9H3MC8XZ7ST'
                }
            ],
            sku: 'K30005-115000',
            grams: 0,
            vendor: 'OFLARA',
            taxable: true,
            product_id: 1592099110963,
            product_has_only_default_variant: true,
            gift_card: false,
            final_price: 999,
            final_line_price: 4995,
            url: '/products/enchanted-rose-pink-drop-pendant-sterling-silver?variant=15469530054707',
            featured_image: {
                aspect_ratio: 0.784,
                alt: 'Rose Pink Crystal Drop Pendant',
                height: 1110,
                url: 'https://cdn.shopify.com/s/files/1/2340/1009/products/K30005-115000.png?v=1542623188',
                width: 870
            },
            image: 'https://cdn.shopify.com/s/files/1/2340/1009/products/K30005-115000.png?v=1542623188',
            handle: 'enchanted-rose-pink-drop-pendant-sterling-silver',
            requires_shipping: true,
            product_type: 'Necklace',
            product_title: 'Rose Pink Crystal Drop Pendant',
            product_description:
                "\nThe more is merrier, just like this deep pink in teardrop but with a perfect frame of an ecstatic design of crystal engraved in silver plating. A unique design just like you loved one. A pretty Valentine's day gift for her. \n",
            variant_title: null,
            variant_options: ['Default Title'],
            options_with_values: [
                {
                    name: 'Title',
                    value: 'Default Title'
                }
            ],
            line_level_discount_allocations: [],
            line_level_total_discount: 0,
            has_components: false
        },
        {
            id: 15469530054707,
            properties: {},
            quantity: 5,
            variant_id: 15469530054707,
            key: '15469530054707:4f323f1a5e4f0dd9505b816b2f68f026',
            title: 'Rose Pink Crystal Drop Pendant',
            price: 999,
            original_price: 999,
            presentment_price: 9.99,
            discounted_price: 949,
            line_price: 4745,
            original_line_price: 4995,
            total_discount: 250,
            discounts: [
                {
                    amount: 250,
                    title: 'SUNDAR-M9H3MC8XZ7ST'
                }
            ],
            sku: 'K30005-115000',
            grams: 0,
            vendor: 'OFLARA',
            taxable: true,
            product_id: 1592099110963,
            product_has_only_default_variant: true,
            gift_card: false,
            final_price: 999,
            final_line_price: 4995,
            url: '/products/enchanted-rose-pink-drop-pendant-sterling-silver?variant=15469530054707',
            featured_image: {
                aspect_ratio: 0.784,
                alt: 'Rose Pink Crystal Drop Pendant',
                height: 1110,
                url: 'https://cdn.shopify.com/s/files/1/2340/1009/products/K30005-115000.png?v=1542623188',
                width: 870
            },
            image: 'https://cdn.shopify.com/s/files/1/2340/1009/products/K30005-115000.png?v=1542623188',
            handle: 'enchanted-rose-pink-drop-pendant-sterling-silver',
            requires_shipping: true,
            product_type: 'Necklace',
            product_title: 'Rose Pink Crystal Drop Pendant',
            product_description:
                "\nThe more is merrier, just like this deep pink in teardrop but with a perfect frame of an ecstatic design of crystal engraved in silver plating. A unique design just like you loved one. A pretty Valentine's day gift for her. \n",
            variant_title: null,
            variant_options: ['Default Title'],
            options_with_values: [
                {
                    name: 'Title',
                    value: 'Default Title'
                }
            ],
            line_level_discount_allocations: [],
            line_level_total_discount: 0,
            has_components: false
        }
    ],
    item_count: 5,
    original_total_price: 4995,
    total_price: 4745,
    total_discount: 250,
    total_weight: 0,
    requires_shipping: true,
    currency: 'USD',
    items_subtotal_price: 4995,
    cart_level_discount_applications: [
        {
            type: 'discount_code',
            key: 'd704d0c8-47ef-45f6-901f-368ca018cee7',
            title: 'SUNDAR-M9H3MC8XZ7ST',
            description: null,
            value: '5.0',
            created_at: '2025-07-02T11:05:36.858Z',
            value_type: 'percentage',
            allocation_method: 'across',
            target_selection: 'all',
            target_type: 'line_item',
            total_allocated_amount: 250
        }
    ],
    discount_codes: [
        {
            code: 'SUNDAR-M9H3MC8XZ7ST',
            applicable: true
        }
    ]
};

const HOST_URL = import.meta.env.VITE_APP_BASE_URL;
const OPENAI_API_KEY = import.meta.env.VITE_OPENAI_API_KEY;

const URLS = {
    cn: 'https://t0xivckoi7.execute-api.us-west-1.amazonaws.com/ask?session=',
    bm: 'https://tu6v0v63c7.execute-api.us-west-1.amazonaws.com/ask?session=',
    shopify: 'Oflara Shopify shopping Agent',
    openai: 'OpenAI Public API'
} as const;

interface IChatMessage {
    _id: string;
    role: 'human' | 'assistant' | 'product';
    content: string;
    introMessage?: string;
    products?: IProductItem[];
    lastResponseId?: string;
    timestamp?: string;
}

interface IChatAPIResponse {
    data: {
        type: string;
        content: string;
        calledToolName: string;
        introMessage: string;
        followUpPrompt: string;
        toolRawResultJsonStringify: string;
        lastResponseId?: string;
        products?: IProductItem[];
        action?: {
            name: string;
            params: Record<string, any>;
        };
    };
    success: boolean;
}

interface IProps {
    agentInfo?: IAgentItem;
    isOpen: boolean;
    onChangeModel: (v: boolean) => void;
    onChangeExpand: (v: boolean) => void;
}

export default function AgentChatbotPC({
    onChangeModel,
    isOpen,
    agentInfo,
    onChangeExpand
}: IProps) {
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [chatHistory, setChatHistory] = useState<IChatMessage[]>([]);
    const [isTyping, setIsTyping] = useState(false);
    const [isOpenResetDialog, setIsOpenResetDialog] = useState(false);
    const [lastResponseId, setLastResponseId] = useState<string | undefined>(
        undefined
    );

    console.log(_mockCartData);

    // UI refs
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const messagesEndRef = useRef<HTMLDivElement>(null);

    const shopifyClient = useMemo(() => {
        return new ShopifyClient({
            storeUrl: agentInfo?.settings.shopify?.store_domain ?? ''
        });
    }, [agentInfo]);

    const onSaveChatInHistory = (data: IChatMessage) => {
        setChatHistory((prev) => [...prev, data]);
        const readOldHistory = localStorage.getItem('bb_chatHistory');

        const oldSession =
            typeof readOldHistory === 'string'
                ? (JSON.parse(readOldHistory) as unknown as IChatMessage[])
                : [];

        localStorage.setItem(
            'bb_chatHistory',
            JSON.stringify([...oldSession, data])
        );
    };

    // Auto-resize textarea
    const adjustInputHeight = () => {
        const el = inputRef.current;
        if (el instanceof HTMLElement) {
            el.style.height = 'auto';
            el.style.height = `${el.scrollHeight}px`;
        }
    };

    const externalApi = async (apiType: string, message: string) => {
        // const apiType = onlyCn ? 'cn' : agentInfo?.settings?.api_type.trim();

        try {
            if (apiType === 'cn' || apiType === 'bm') {
                const res = await fetch(URLS[apiType as keyof typeof URLS], {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        query: message
                    })
                });

                const data = await res.json();
                return data.answer;
            }

            const res = await fetch(
                'https://api.openai.com/v1/chat/completions',
                {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${OPENAI_API_KEY}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        model: 'gpt-4',
                        messages: [
                            {
                                role: 'system',
                                content:
                                    'You are a helpful assistant. Respond clearly, use Markdown if needed.'
                            },
                            { role: 'user', content: message }
                        ]
                    })
                }
            );

            const data = await res.json();
            return data.choices[0].message.content;
        } catch (error) {
            console.log(error);
        }
    };

    const handleFormSubmit = async ({ message }: { message: string }) => {
        if (!message.trim()) return;

        setIsLoading(true);
        setIsTyping(true);

        // Save user message in History
        onSaveChatInHistory({
            _id: Date.now().toString(),
            role: 'human',
            content: message,
            timestamp: new Date().toDateString()
        });

        // Clear input
        setMessage('');

        try {
            const apiType = agentInfo?.settings?.api_type.trim() as string;
            const externalAgents = ['cn', 'bm', 'openai'];

            // @todo- It will be delete in later
            if (externalAgents.includes(apiType)) {
                const data = await externalApi(apiType, message);

                onSaveChatInHistory({
                    _id: new Date().toDateString(),
                    role: 'assistant',
                    content: data,
                    products: [],
                    introMessage: ''
                });

                return;
            }

            const res = await fetch(HOST_URL + '/api/chat', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    message: message,
                    agentId: agentInfo?._id,
                    lastResponseId: lastResponseId
                })
            });

            if (!res.ok) {
                onSaveChatInHistory({
                    _id: Date.now().toString(),
                    role: 'assistant',
                    content:
                        "I'm sorry, I encountered an error while processing your request. Please try again.",
                    timestamp: new Date().toDateString()
                });

                return;
            }

            const result = (await res.json()) as IChatAPIResponse;
            console.log('Chat API response:', result);

            if (result.data?.action) {
                const action = result.data.action
                    .name as keyof typeof shopifyClient;

                if (typeof shopifyClient[action] === 'function') {
                    const params = result.data.action.params;

                    const output = shopifyClient[action](params);

                    console.log(output, 'params...');
                }
            }

            onSaveChatInHistory({
                _id: result.data.lastResponseId ?? new Date().toDateString(),
                role: 'assistant',
                content:
                    result.data.type === 'products'
                        ? result.data.products
                            ? result.data.followUpPrompt
                            : result.data.introMessage
                        : result.data.content,
                products: result.data.products,
                introMessage: result.data.introMessage
            });

            setLastResponseId(result.data.lastResponseId);
            setIsLoading(false);
        } catch (error) {
            console.error('Form Submit error:', error);

            onSaveChatInHistory({
                _id: Date.now().toString(),
                role: 'assistant',
                content:
                    "I'm sorry, I encountered an error while processing your request. Please try again.",
                timestamp: new Date().toDateString()
            });
        } finally {
            setIsLoading(false);
            setIsTyping(false);
        }
    };

    // Form submission
    const onSubmit = async (e: any) => {
        e.preventDefault();
        const type = agentInfo?.settings?.api_type.trim();

        if (type) await handleFormSubmit({ message });
    };

    // Handle Enter key
    const onHandleKeyDown = (e: any) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            onSubmit(e);
        }
    };

    // Reset chat history
    const onResetChatHistory = (value: boolean) => {
        if (value) {
            localStorage.removeItem('bb_chatHistory');
            setChatHistory([]);
            setLastResponseId(undefined);
        }
        setIsOpenResetDialog(false);
    };

    const onChangeProductAction = (
        product: IProductItem,
        type: 'view' | 'addToCart'
    ) => {
        if (type === 'addToCart') {
            onSaveChatInHistory({
                _id: new Date().toDateString(),
                role: 'human',
                content: `Please add the "${product.title}" to my cart.`,
                products: [],
                introMessage: ''
            });

            shopifyClient.add_to_cart({
                variant_id: product.variant_id,
                quantity: 1
            });

            onSaveChatInHistory({
                _id: new Date().toDateString(),
                role: 'assistant',
                content: `The **"${product.title}"** has been added to your cart.`,
                products: [],
                introMessage: ''
            });

            return;
        }

        if (type === 'view') {
            onSaveChatInHistory({
                _id: new Date().toDateString(),
                role: 'assistant',
                content: `You've viewed the product details of the **"${product.title}"** — the page opened in a new tab in your browser.`,
                products: [],
                introMessage: ''
            });

            return;
        }
    };

    // Load chat history from localStorage on mount
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const savedHistory = localStorage.getItem('bb_chatHistory');
            if (savedHistory) {
                try {
                    const parsedHistory = JSON.parse(
                        savedHistory
                    ) as IChatMessage[];

                    const filteredAssistantRes = (parsedHistory ?? []).filter(
                        (_) => _?.lastResponseId
                    );

                    setChatHistory(parsedHistory);
                    setLastResponseId(filteredAssistantRes[-1]?.lastResponseId);
                } catch (error) {
                    console.error(
                        '[SIMPLIFIED] Error loading chat history:',
                        error
                    );
                }
            }
        }
    }, []);

    // Auto-scroll to bottom
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [chatHistory]);

    useEffect(() => {
        if (isOpen) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'auto' });
        }
    }, [isOpen]);

    // Handle external events
    useEffect(() => {
        const handler = (event: CustomEvent) => {
            if (event.detail) {
                onChangeModel(true);
                handleFormSubmit({ message: event.detail });
            }
        };

        window.addEventListener(
            'boostbuddy-custom-event',
            handler as EventListener
        );
        return () =>
            window.removeEventListener(
                'boostbuddy-custom-event',
                handler as EventListener
            );
    }, []);

    return (
        <div className='bb-ai-agent'>
            <style>
                {StyleVariables(
                    'wc',
                    agentInfo?.settings?.message_bg_color || '#3387d7',
                    agentInfo?.settings?.header_bg_color || '#3387d7',
                    agentInfo?.settings?.border_radius || '14',
                    agentInfo?.settings?.chatbot_width || '400'
                )}
            </style>

            <ChatbotContainer>
                {/* Header */}
                <ChatbotHeader>
                    <div className='b-agent__header-brand'>
                        {agentInfo?.settings?.brand_url && (
                            <div className={ChatbotHeaderLogo}>
                                <img
                                    src={
                                        HOST_URL + agentInfo.settings.brand_url
                                    }
                                    alt='logo'
                                    width={100}
                                    height={100}
                                />
                            </div>
                        )}
                        <h2 className='b-agent__brand-name'>
                            {agentInfo?.name ?? 'BoostBuddy'}
                        </h2>
                    </div>
                    <ChatbotHeaderAction>
                        <button
                            onClick={() => setIsOpenResetDialog(true)}
                            aria-label='Refresh'
                            disabled={chatHistory.length < 1}
                        >
                            <RefreshCcw size={18} />
                        </button>
                        <button
                            aria-label='Maximize'
                            onClick={() => onChangeExpand(true)}
                        >
                            <Maximize2 size={18} />
                        </button>
                        <button
                            onClick={() => onChangeModel(false)}
                            aria-label='Close'
                        >
                            <X size={22} />
                        </button>
                    </ChatbotHeaderAction>
                </ChatbotHeader>

                {/* Messages */}
                <MessagesWrapper>
                    <IntroMessage>
                        {agentInfo?.settings?.welcome_message ||
                            "Welcome! I'm your virtual assistant. How can I help you today?"}
                    </IntroMessage>

                    {/* Suggestion buttons */}
                    {agentInfo?.settings?.suggestion_messages?.map(
                        ({ message }) => (
                            <button
                                className={MessageItemStarting}
                                key={message}
                                onClick={() => handleFormSubmit({ message })}
                            >
                                {message}
                            </button>
                        )
                    )}

                    {/* Chat messages */}
                    {chatHistory.map((chat) => {
                        return (
                            <>
                                {chat.products && (
                                    <ProductsList
                                        key={chat._id}
                                        products={chat.products ?? []}
                                        onChange={onChangeProductAction}
                                        introMessage={chat.introMessage}
                                    />
                                )}

                                <div
                                    className={
                                        chat.role === 'assistant'
                                            ? MessagesItemAssistant
                                            : MessagesItemHuman
                                    }
                                    key={chat._id}
                                >
                                    <ReactMarkdown
                                        remarkPlugins={[remarkGfm]}
                                        components={{
                                            a: ({ node, ...props }) => (
                                                <a
                                                    {...props}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                >
                                                    {props.children}
                                                    <LinkIcon />
                                                </a>
                                            )
                                        }}
                                    >
                                        {chat.content}
                                    </ReactMarkdown>
                                </div>
                            </>
                        );
                    })}

                    {isTyping && <TypingIndicator />}
                    <div ref={messagesEndRef} />
                </MessagesWrapper>

                {/* Input form */}
                <MessageForm onSubmit={onSubmit} onKeyDown={onHandleKeyDown}>
                    <textarea
                        className={MessageFormInput}
                        disabled={isLoading || !agentInfo}
                        ref={inputRef}
                        placeholder={
                            agentInfo?.settings?.placeholder_message ||
                            (!agentInfo
                                ? 'Invalid BoostBuddy API Key'
                                : 'Type your message...')
                        }
                        rows={1}
                        onChange={(e: any) => setMessage(e.target.value)}
                        onInput={adjustInputHeight}
                        value={message}
                        style={
                            !agentInfo
                                ? {
                                      background: '#fb9c8e40',
                                      borderColor: '#ff806d'
                                  }
                                : {}
                        }
                    />
                    <MessageFormBtn
                        type='submit'
                        disabled={isLoading || !message.trim()}
                    >
                        <SendHorizonal size={18} />
                    </MessageFormBtn>
                </MessageForm>

                {/* Footer */}
                <ChatbotFooter>
                    Powered by{' '}
                    <a
                        href='https://brillmark.com/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <img
                            src={`${HOST_URL}` + '/images/brillmark-logo.svg'}
                            alt='brillmark'
                            width={40}
                            height={40}
                        />
                    </a>
                </ChatbotFooter>
            </ChatbotContainer>

            {isOpenResetDialog && (
                <ConfirmationDialog onChange={onResetChatHistory} />
            )}
        </div>
    );
}

// Helper components
const LinkIcon = () => (
    <svg
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 768 768'
    >
        <path
            fill='inherit'
            d='M544 416v192c0 8.832-3.552 16.8-9.376 22.624s-13.792 9.376-22.624 9.376h-352c-8.832 0-16.8-3.552-22.624-9.376s-9.376-13.792-9.376-22.624v-352c0-8.832 3.552-16.8 9.376-22.624s13.792-9.376 22.624-9.376h192c17.664 0 32-14.336 32-32s-14.336-32-32-32h-192c-26.496 0-50.56 10.784-67.872 28.128s-28.128 41.376-28.128 67.872v352c0 26.496 10.784 50.56 28.128 67.872s41.376 28.128 67.872 28.128h352c26.496 0 50.56-10.784 67.872-28.128s28.128-41.376 28.128-67.872v-192c0-17.664-14.336-32-32-32s-32 14.336-32 32zM342.624 470.624l297.376-297.376v114.752c0 17.664 14.336 32 32 32s32-14.336 32-32v-192c0-4.352-0.864-8.48-2.432-12.256s-3.872-7.296-6.912-10.336c-0.032-0.032-0.032-0.032-0.064-0.064-2.944-2.944-6.464-5.312-10.336-6.912-3.776-1.568-7.904-2.432-12.256-2.432h-192c-17.664 0-32 14.336-32 32s14.336 32 32 32h114.752l-297.376 297.376c-12.512 12.512-12.512 32.768 0 45.248s32.768 12.512 45.248 0z'
        />
    </svg>
);

const TypingIndicator = () => (
    <div className={typingIndicator}>
        <span className={pulseDot1}></span>
        <span className={pulseDot2}></span>
        <span className={pulseDot3}></span>
    </div>
);

interface IConfirmationDialog {
    onChange: (v: boolean) => void;
}

const ConfirmationDialog = ({ onChange }: IConfirmationDialog) => (
    <div className={dialogWrapper}>
        <div
            className={dialog}
            role='dialog'
            aria-labelledby='dialog-title'
            aria-describedby='dialog-description'
        >
            <h2 id='dialog-title' className={dialogTitle}>
                Close Conversation
            </h2>
            <p id='dialog-description' className={dialogDescription}>
                All messages in this chat will be deleted. Do you want to
                proceed?
            </p>
            <div className={dialogActions}>
                <button
                    type='button'
                    onClick={() => onChange(false)}
                    className={`${buttonSecondary} ${button}`}
                >
                    Cancel
                </button>
                <button
                    type='button'
                    onClick={() => onChange(true)}
                    className={`${buttonPrimary} ${button}`}
                >
                    Close
                </button>
            </div>
        </div>
    </div>
);
